import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { installVisibilityInterceptors } from "@/lib/visibility";

// Install global response filters for contract-fixture athletes (Admin/Staff UI only).
installVisibilityInterceptors();

// Suppress benign ResizeObserver loop errors (caused by Recharts ResponsiveContainer)
// This is a known browser-level warning that does not affect functionality
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true;
  }
  if (resizeObserverErr) return resizeObserverErr(message, ...args);
};

// Also suppress the unhandled promise rejection variant
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
